<template>
  <div class="verify-form">
    <Title :name="$t('zu-zhi-xin-xi')" />
    <a-alert class="mt-[20px] mb-[32px]" type="info" showIcon>
      >
      <template #message>
        <span class="text-font-1">
          {{
            $t(
              'qing-que-bao-gong-shang-deng-ji-ming-cheng-huo-zu-zhi-ming-cheng-shang-chuan-de-ying-ye-zhi-zhao-huo-qi-ta-zheng-ming-zhong-de-gong-si-huo-zu-zhi-ming-cheng-ren-zheng-gong-han-zhong-jia-gai-gong-zhang-de-ming-cheng-san-zhe-yi-zhi'
            )
          }}
        </span>
      </template>
    </a-alert>
    <a-form ref="formRef" layout="vertical" :model="formState">
      <a-form-item
        name="name"
        :label="$t('1-qi-ye-huo-zu-zhi-ming-cheng')"
        :rules="[
          {
            required: true,
            message: $t(
              'qing-shu-ru-gong-shang-deng-ji-ming-cheng-huo-zu-zhi-ming-cheng'
            ),
          },
          {
            min: 4,
            message: $t('zhi-shao-shu-ru-4-ge-zi-fu'),
            trigger: 'blur',
          },
        ]"
      >
        <a-input
          v-model:value="formState.name"
          :placeholder="
            $t(
              'qing-shu-ru-gong-shang-deng-ji-ming-cheng-huo-zu-zhi-ming-cheng'
            )
          "
          :minLength="4"
          :maxlength="100"
          class="max-w-[366px]"
          :disabled="disabled"
        />
      </a-form-item>
      <a-form-item
        name="identify_img"
        :label="$t('2-ying-ye-zhi-zhao-huo-qi-ta-zheng-ming-cai-liao')"
        :rules="[
          {
            required: true,
            message: $t(
              'qing-shang-chuan-ying-ye-zhi-zhao-huo-qi-ta-zheng-ming-cai-liao'
            ),
          },
        ]"
      >
        <div class="text-14 text-font-60 mb-[10px]">
          {{
            $t(
              'shang-chuan-you-xiao-qi-nei-de-ying-ye-zhi-zhao-shang-biao-zhu-ce-zheng-shu-ji-shang-biao-shou-quan-shu-huo-qi-ta-zheng-ming-cai-liao-zhi-chi-jpgjpegpngpdf-ge-shi-da-xiao-bu-chao-guo-5mb'
            )
          }}
        </div>
        <UploadFile
          v-model="formState.identify_img"
          :disabled="disabled"
          :accept="['jpg', 'jpeg', 'png', 'pdf']"
          class="w-[158px] h-[180px]"
          :text="$t('jin-zhi-chi-jpgjpegpngpdf-ge-shi')"
          :desc="$t('da-xiao-bu-chao-guo-5-mb')"
          :max="5"
        />
      </a-form-item>
      <a-form-item
        v-if="!isGlobalVersion()"
        :label="$t('3-ren-zheng-gong-han')"
        name="authorization_img"
        :rules="[
          {
            required: true,
            message: $t('qing-shang-chuan-ren-zheng-gong-han'),
          },
        ]"
      >
        <div class="text-14 my-[10px] text-font-1">
          {{ $t('qing') }}
          <a
            :href="
              getFeUrl(
                '/youyan-platform/file/%E8%AE%A4%E8%AF%81%E6%8E%88%E6%9D%83%E5%87%BD.docx'
              )
            "
          >
            {{ $t('xia-zai-ren-zheng-gong-han') }}
          </a>
          {{
            $t(
              'bing-an-yao-qiu-tian-xie-xin-xi-suo-you-xin-xi-xu-qing-xi-ke-jian-nei-rong-zhen-shi-you-xiao-bu-de-zuo-ren-he-xiu-gai'
            )
          }}
          <a @click="showPreview">{{ $t('cha-kan-shi-li-tu') }}</a>
        </div>
        <UploadFile
          v-model="formState.authorization_img"
          :disabled="disabled"
          :accept="['jpg', 'jpeg', 'png', 'pdf']"
          class="w-[158px] h-[180px]"
          :text="$t('jin-zhi-chi-jpgjpegpngpdf-ge-shi')"
          :desc="$t('da-xiao-bu-chao-guo-5-mb')"
          :max="5"
        />
      </a-form-item>
      <Title :name="$t('shou-quan-guan-li-yuan')" class="mt-[40px] mb-[32px]" />
      <a-form-item
        name="legal_person_name"
        :label="
          !isGlobalVersion()
            ? $t('4-guan-li-yuan-xing-ming')
            : $t('3-guan-li-yuan-xing-ming')
        "
        :rules="[
          {
            required: true,
            message: $t(
              'qing-shu-ru-shou-quan-shu-zhong-shou-quan-de-guan-li-yuan-xing-ming'
            ),
          },
        ]"
      >
        <a-input
          v-model:value="formState.legal_person_name"
          :placeholder="
            $t(
              'qing-shu-ru-shou-quan-shu-zhong-shou-quan-de-guan-li-yuan-xing-ming'
            )
          "
          class="max-w-[366px]"
          :disabled="disabled"
        />
      </a-form-item>
      <a-form-item
        v-if="!isGlobalVersion()"
        name="legal_person_phone"
        :label="$t('5-guan-li-yuan-shou-ji-hao')"
      >
        <div v-if="!disabled" class="text-14 text-font-60 mb-[10px]">
          {{ $t('ru-shou-ji-hao-bu-zheng-que-qing')
          }}<a @click="changePhone">{{
            $t('geng-gai-dang-qian-guan-li-yuan-shou-ji-hao')
          }}</a>
        </div>
        <a-input
          v-model:value="formState.legal_person_phone"
          :placeholder="$t('qing-shu-ru-guan-li-yuan-shou-ji-hao')"
          class="max-w-[366px]"
          :disabled="true"
        />
      </a-form-item>
      <a-form-item
        v-else
        name="legal_person_email"
        :label="$t('4-guan-li-yuan-you-xiang')"
      >
        <div v-if="!disabled" class="text-14 text-font-60 mb-[10px]">
          {{ $t('ru-you-xiang-bu-zheng-que-qing')
          }}<a @click="changePhone">{{
            $t('geng-gai-dang-qian-guan-li-yuan-you-xiang')
          }}</a>
        </div>
        <a-input
          v-model:value="formState.legal_person_email"
          :placeholder="$t('qing-shu-ru-guan-li-yuan-you-xiang')"
          class="max-w-[366px]"
          :disabled="true"
        />
      </a-form-item>
      <a-form-item>
        <!-- {{ disabled }}
        {{ data?.identify_info?.status === USER_VERIFY_STATUS.SUCCESS }} -->
        <NuxtLink
          v-if="
            disabled &&
            data?.identify_info?.status === USER_VERIFY_STATUS.SUCCESS
          "
          :to="{ name: PageKey.ACCOUNT_VERIFY }"
        >
          <a-button type="primary" class="w-[162px]" @click="emits('reset')">
            {{ $t('zhong-xin-ren-zheng') }}
          </a-button>
        </NuxtLink>
        <template
          v-if="data?.identify_info?.status === USER_VERIFY_STATUS.WAIT"
        >
          <a-popconfirm
            :disabled="!isCanSubmit"
            :ok-text="$t('che-hui')"
            :cancel-text="$t('qu-xiao')"
            @confirm="onCancel"
          >
            <template #title>
              <div class="w-[216px]">
                {{
                  $t(
                    'che-hui-ren-zheng-shen-qing-hou-xu-yao-zhong-xin-tian-xie-ren-zheng-cai-liao-jin-hang-ren-zheng-que-ren-che-hui-shen-qing'
                  )
                }}
              </div>
            </template>
            <a-button type="primary" class="w-[162px]">
              {{ $t('che-hui-shen-qing') }}
            </a-button>
          </a-popconfirm>
        </template>
        <template v-if="!disabled">
          <a-button
            v-if="
              !data?.is_identify && data?.identify_info?.status === undefined
            "
            type="primary"
            class="w-[162px] mr-[16px]"
            ghost
            @click="onSave"
          >
            {{ $t('bao-cun-cao-gao') }}
          </a-button>
          <a-popconfirm
            :ok-text="$t('que-ren')"
            :cancel-text="$t('qu-xiao')"
            @confirm="onSubmit"
          >
            <template #title>
              <div class="w-[216px]">
                {{
                  $t(
                    'ti-jiao-hou-jiang-jin-ru-ren-zheng-xin-xi-shen-he-jie-duan-yu-ji-3-ge-gong-zuo-ri-nei-wan-cheng-shen-he-qing-que-ren-ren-zheng-xin-xi-zhun-que-wu-wu-hou-ti-jiao'
                  )
                }}
              </div>
            </template>
            <a-button type="primary" :disabled="!isCanSubmit" class="w-[162px]">
              {{ $t('ti-jiao-shen-he-0') }}
            </a-button>
          </a-popconfirm>
        </template>
      </a-form-item>
    </a-form>
    <ChangePhone ref="phoneRef" :currentPhone="userInfo.phone_number" />
  </div>
</template>

<script lang="ts" setup>
import Title from './title.vue'
import UploadFile from '~/features/uploadImg/index.vue'
import ChangePhone from '~/features/account/changePhone/index.vue'
import { type UserVerifyInfo } from '~/api/interface'
import { USER_VERIFY_STATUS } from '~/constants'
import {
  saveVerifyInfo,
  sendVerifyInfo,
  editVerifyInfo,
  cancelVerify,
} from '~/api'
import { PageKey } from '~/constants/page'
import { useImgsView } from '~/hooks/useModal/modals/view'
interface FormState {
  name: string
  identify_img: string
  authorization_img: string
  legal_person_name: string
  legal_person_phone: string
  legal_person_email: string
}

const emits = defineEmits(['reset', 'set', 'reload'])

const props = defineProps<{
  data?: UserVerifyInfo
  disabled?: boolean
}>()

const userInfo = useUserInfo()
const phoneRef = ref()
const formRef = ref()
const formState = reactive<FormState>({
  name: props.data?.identify_info?.name || '',
  identify_img: props.data?.identify_info?.identify_img || '',
  authorization_img: props.data?.identify_info?.authorization_img || '',
  legal_person_name: props.data?.identify_info?.legal_person_name || '',
  legal_person_phone:
    props.data?.identify_info?.legal_person_phone ||
    userInfo.value?.phone_number,
  legal_person_email:
    props.data?.identify_info?.legal_person_email ||
    userInfo.value?.email_address,
})
const isCanSubmit = computed(
  () =>
    formState?.name &&
    formState?.identify_img &&
    (isGlobalVersion() ? true : formState?.authorization_img) &&
    formState?.legal_person_name &&
    formState?.legal_person_phone
)

watch(
  () => props.data,
  (cur: any, bef: any) => {
    if (cur !== bef) {
      Object.assign(formState, props.data?.identify_info)
    }
  }
)
const changePhone = () => {
  phoneRef.value.toggle?.()
}

const showPreview = () => {
  useImgsView([getFeUrl('/youyan-platform/png/verify-file.png')])
}
const { $t } = useNuxtApp()

const onSave = async () => {
  const res = await saveVerifyInfo(formState)

  if (!res.code && res.data) {
    message.success($t('bao-cun-cao-gao-cheng-gong'))
  }
}

const onCancel = async () => {
  if (props.data?.identify_info?.id) {
    const res = await cancelVerify(props.data?.identify_info?.id)
    if (!res.code && res.data) {
      message.success($t('che-hui-shen-qing-cheng-gong'))
      emits('reload')
    }
  }
}

const onSubmit = () => {
  formRef.value
    .validate()
    .then(async () => {
      // 认证成功的信息再次提交需要用PUT接口
      const action =
        props.data?.identify_info?.status === USER_VERIFY_STATUS.SUCCESS
          ? editVerifyInfo
          : sendVerifyInfo
      const res = await action(formState)
      if (!res.code && res.data) {
        message.success($t('ti-jiao-shen-he-cheng-gong'))
        emits('reload')
      }
    })
    .catch((error: any) => {
      console.log('error', error)
    })
}
</script>

<style lang="scss" scoped>
.verify-form {
  @apply bg-back-2 p-[40px_86px] mt-[40px] rounded-[18px];
  :deep(.ant-form-item-label) {
    label {
      @apply text-16 font-medium text-font-1;
      &::before {
        display: none;
      }
    }
  }
  :deep(.ant-form-item-required) {
    &::before {
      display: none !important;
    }
    &::after {
      display: inline-block;
      margin-left: 4px;
      color: #ff5656;
      font-size: 14px;
      line-height: 1;
      content: '*';
    }
  }
}
</style>
